/**
 * A fresh client id for a send, a lowercase v4 UUID as the server validates and echoes
 * it. `crypto.randomUUID` needs a secure context; elsewhere it falls back to Math.random,
 * which is enough to tell one browser's sends apart.
 */
export const newClientId = (): string => {
	if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID()
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
		const r = (Math.random() * 16) | 0
		return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
	})
}
